module.exports = __webpack_public_path__ + "img/data-item1-4.0b5e778.png";